/* eslint-disable react/require-default-props */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { ReactElement, useEffect, useRef, useState } from 'react';

import {
  Button,
  ChevronRightIcon,
  NullIcon,
  ArrowForwardIosIcon,
} from 'elmo-elements';
import { FrameDataType } from '@/modules/types/frame';

interface MenuViewType {
  isVisible: boolean;
  frames: undefined | FrameDataType[];
  closeMenu: () => void;
  elearningId?: string;
  frameId?: string;
  onClickLink: (nextFrameId: string) => void;
}

const MenuView = ({
  isVisible,
  frames,
  closeMenu,
  elearningId,
  frameId,
  onClickLink,
}: MenuViewType): ReactElement => {
  const [isMenuButtonDisabled, setIsMenuButtonDisabled] = useState({
    up: true,
    down: false,
  });

  const menuRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const menuElement = menuRef.current;

    const scrollEventFunction = () => {
      if (menuElement)
        setIsMenuButtonDisabled({
          up: menuElement.scrollTop <= 0,
          down:
            menuElement.scrollTop >=
            menuElement.scrollHeight - menuElement.offsetHeight,
        });
    };

    if (menuElement && !menuElement.hasAttribute('scrollEventAttached')) {
      menuElement.setAttribute('scrollEventAttached', 'scrollEventAttached'); // to add event listener once only
      menuElement.addEventListener('scroll', scrollEventFunction);
      scrollEventFunction();
    }
  });

  function NumToString(num: number) {
    const returnNum = num < 10 ? `0${num}` : num;
    return `${returnNum}: `;
  }

  const menuButtonHandler = (direction: string) => {
    const menuElement = menuRef.current;
    if (menuElement) {
      const newScrollTop =
        menuElement.scrollTop +
        menuElement.offsetHeight * (direction === 'up' ? -1 : 1);
      menuElement.scrollTop = newScrollTop;
    }
  };

  const onClickHandler = (nextFrameId: string) => {
    onClickLink(nextFrameId);
  };

  if (!frames) return <div />;

  return (
    <>
      <Button
        onClick={closeMenu}
        className={`module-viewer-menu__btn-background ${
          isVisible && 'is-visible'
        }`}
      >
        <NullIcon />
      </Button>
      <div
        className={`module-viewer-menu__wrapper ${isVisible && 'is-visible'}`}
      >
        <Button
          isText={true}
          onClick={() => menuButtonHandler('up')}
          isDisabled={isMenuButtonDisabled.up}
          className="module-viewer-menu__btn-scroll-up"
        >
          <ArrowForwardIosIcon className="icon-rotate-270" />
        </Button>
        <div className="module-viewer-menu" ref={menuRef}>
          <ul className="module-viewer-menu__list">
            {frames.map((frame: any, index: number) => (
              <li key={`MenuLink-${index}`}>
                <Button
                  onClick={() => {
                    onClickHandler(frame.id);
                  }}
                  className="module-viewer-menu__link"
                  type="default"
                  isText={true}
                  isUppercase={false}
                >
                  {frameId === frame.id ? <ChevronRightIcon /> : <NullIcon />}
                  <span className="module-viewer-menu__list-title">
                    {NumToString(index)}
                    {frame.title}
                  </span>
                </Button>
              </li>
            ))}
          </ul>
        </div>
        <Button
          isText={true}
          isDisabled={isMenuButtonDisabled.down}
          onClick={() => menuButtonHandler('down')}
          className="module-viewer-menu__btn-scroll-down"
        >
          <ArrowForwardIosIcon className="icon-rotate-90" />
        </Button>
      </div>
    </>
  );
};

export default MenuView;
